import React from "react";
import { Navbar, Button, Container } from "react-bootstrap";
import { Link as ScrollLink } from "react-scroll";
import { useTranslation } from 'react-i18next';
import "./Header.css";
import logo from "../../assets/images/logo.png";

function Header() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language;
  const oppositeLanguage = currentLanguage === 'ar' ? 'en' : 'ar';

  return (
    <>
      {/* ✅ Top Bar */}
      <div className="topbar py-1 small text-white text-center d-none d-md-block">
        <Container>
          <div className={`d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 gap-md-4 ${currentLanguage === 'ar' ? 'rtl' : 'ltr'}`}>
            <span className="d-flex align-items-center gap-1">
              <img src="/assets/icons/location.png" alt={t('header.address')} height="16" />
              {t('header.address')}
            </span>

            <span className="d-flex align-items-center gap-1">
              <span 
  className="text-white" 
  style={{ direction: 'ltr', unicodeBidi: 'bidi-override' }}
>
  {t('header.phone')}
</span>

              <a href="tel:+966509101166">
                <img src="/assets/icons/phone.png" alt={t('header.phone')} height="16" />
              </a>
              <a href="https://wa.me/966509101166" target="_blank" rel="noopener noreferrer">
                <img src="/assets/icons/whatsapp.png" alt="WhatsApp" height="16" />
              </a>
            </span>

            <span className="d-flex align-items-center gap-1">
              {t('header.email')}
              <img src="/assets/icons/email.png" alt={t('header.email')} height="16" />
            </span>

            
          </div>
        </Container>
      </div>

      {/* ✅ Main Navigation - Sticky */}
      <div className="sticky-navbar section-container">
        <Navbar
  key={currentLanguage}   
  expand="lg"
  className="navbar-custom py-3 py-lg-2"
  dir={currentLanguage === 'ar' ? 'rtl' : 'ltr'}
  collapseOnSelect
>

          <Navbar.Brand href="#home" className={currentLanguage === 'ar' ? 'me-auto me-lg-0' : 'ms-auto ms-lg-0'}>
            <img src={logo} alt="Taamir Najd" height="40" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar" className="border-0" />

          <Navbar.Collapse id="main-navbar">
            <div className={`d-flex flex-column flex-lg-row align-items-center gap-3 my-3 my-lg-0 ${currentLanguage === 'ar' ? 'ms-lg-auto' : 'me-lg-auto'}`}>
              <ScrollLink to="home" spy={true} smooth={true} offset={-70} duration={500} className="nav-link m-0" activeClass="active">
                {t('header.home')}
              </ScrollLink>
              <ScrollLink to="about" spy={true} smooth={true} offset={-70} duration={500} className="nav-link" activeClass="active">
                {t('header.about')}
              </ScrollLink>
              <ScrollLink to="services" spy={true} smooth={true} offset={-70} duration={500} className="nav-link" activeClass="active">
                {t('header.services')}
              </ScrollLink>
              <ScrollLink to="projects" spy={true} smooth={true} offset={-70} duration={500} className="nav-link" activeClass="active">
                {t('header.projects')}
              </ScrollLink>
              <ScrollLink to="clients" spy={true} smooth={true} offset={-70} duration={500} className="nav-link" activeClass="active">
                {t('header.clients')}
              </ScrollLink>
              <ScrollLink to="contact" spy={true} smooth={true} offset={-70} duration={500} className="nav-link" activeClass="active">
                {t('header.contact')}
              </ScrollLink>

              <a 
  href="../taamir-najd-profile.pdf" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="btn btn-custom mt-2 mt-lg-0"
>
  {t('header.profile')}
</a>




<span 
  className="language-switcher ms-3"
  onClick={() => changeLanguage(oppositeLanguage)}
  style={{ cursor: 'pointer', fontSize: '18px' }}
>
  {currentLanguage === 'ar' ? '🌐 EN' : '🌐 AR'}
</span>

            </div>
          </Navbar.Collapse>
        </Navbar>
      </div>
    </>
  );
}

export default Header;